import { render, staticRenderFns } from "./CookiesFr.vue?vue&type=template&id=1d8fc036"
import script from "./CookiesFr.vue?vue&type=script&lang=js"
export * from "./CookiesFr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports